// extracted by mini-css-extract-plugin
export default {"container":"_16ym_","header":"_1Qazb","closeIcon":"_2yCkR"};